module.exports = __webpack_public_path__ + "k.no1.7c6c4f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/k.no1.jpg
// module id = qz4A
// module chunks = 0